package services.http

import it.neckar.lizergy.model.company.CompanyCode
import it.neckar.lizergy.model.project.previews.AccountingProjectPreview
import it.neckar.lizergy.model.project.previews.ProjectQueryComponent
import it.neckar.lizergy.model.project.process.state.LizergyProcessStates
import it.neckar.user.UserLoginName
import kotlinx.serialization.Serializable

@Serializable
data class AccountingProjectQueryRequest(
  val processStatesToFilter: List<@Serializable(with = LizergyProcessStatesSerializer::class) LizergyProcessStates>,
  val processStatesToHide: List<@Serializable(with = LizergyProcessStatesSerializer::class) LizergyProcessStates>,
  val accountingQuerySelection: AccountingQuerySelection,
  val filteredByCompanyCode: CompanyCode?,
  val filteredByMaintainer: UserLoginName?,
  val filteredByEditor: UserLoginName?,
  val filterValueProject: String?,
  val filterValueAddress: String?,
  val filterByProjectState: @Serializable(with = LizergyProcessStatesSerializer::class) LizergyProcessStates?,
  val indexOfFirstVisibleProject: Int,
  val indexOfLastVisibleProject: Int,
  val sorting: ProjectQuerySorting,
  val projectQueryComponent: ProjectQueryComponent?,
  val howDoYouLikeYourQuoteElements: AccountingProjectPreview.QuoteElements,
  val loggedInUser: UserLoginName,
)

@Serializable
enum class AccountingQuerySelection {
  All,
  PendingForAccounting,
  SelectedForAccounting,
  Accounted,
}
